import MojitoCore from 'mojito/core';
const UIView = MojitoCore.Presentation.UIView;
import PrebuiltBetsViewImpl from './pre-built-bets-view.js';

/**
 * PrebuiltBetsView - renders pre build bet builder content inside SportPage.
 *
 * @class PrebuiltBetsView
 * @memberof Mojito.Applications.Sports.Pages
 */
export default UIView('PrebuiltBetsView', PrebuiltBetsViewImpl);
